export default __webpack_public_path__ + "static/media/hydrobase.d2ecceba.jpg";